// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Stable diagnostic numbers, grouped by tens. A number is never reused.
 * Numbers 80 to 99 belong to the events parser.
 */
export enum DiagnosticCode {
  Unspecified = 0,
  NotUtf8 = 1,
  TooLarge = 2,
  MalformedRequest = 3,
  DiagnosticsSuppressed = 4,
  InvalidFileName = 5,
  DuplicateFileName = 6,
  HostTrap = 7,
  BadDeflate = 8,
  BlobKindMismatch = 9,
  ParseError = 10,
  TrailingInput = 11,
  UnknownAnnotation = 12,
  NestingTooDeep = 13,
  ByteOrderMark = 14,
  InflateLimitExceeded = 15,
  BlobMalformed = 16,
  MissingInterface = 20,
  MissingVersion = 21,
  UnresolvedInclude = 22,
  IncludeCycle = 23,
  IncludeTooDeep = 24,
  ProductInterfaceMismatch = 25,
  InvalidIncludePath = 26,
  SharedIncludeDiffers = 27,
  MissingProductType = 28,
  UnusedUpload = 29,
  DuplicateKey = 30,
  ShadowedCommentId = 31,
  ExpansionOverlap = 32,
  CrossCategoryKey = 33,
  UnaddressableEntry = 34,
  IdOverflow = 35,
  UndefinedArrayLength = 40,
  UnknownExpansionVariable = 41,
  ArrayLengthOutOfRange = 42,
  UndefinedType = 50,
  DanglingReturnType = 51,
  DuplicateTypeName = 52,
  DuplicateEnumValue = 53,
  EnumValueOutOfRange = 54,
  RecursiveStruct = 55,
  VersionNewerThanSchema = 56,
  ProfileNameMismatch = 60,
  Unmapped = 61,
  ProfileOnlyRow = 62,
  InvalidOverride = 63,
  TemplateShapeMismatch = 64,
  DecodeWidthMismatch = 65,
  MappingTooLarge = 66,
  UnspecifiedEnumValue = 67,
  ShaMismatch = 70,
  TableInputMismatch = 71,
  RebuildMismatch = 72,
  FormatVersionUnsupported = 73,
  RebuildSkew = 74,
  CanaryMismatch = 75,
  XmlNotWellFormed = 80,
  MissingEventsNode = 81,
  MissingEventAttribute = 82,
  BadEventId = 83,
  BadEventBool = 84,
  DuplicateEventId = 85,
  EmptyEvents = 86,
  EventFamilyMismatch = 87,
  EventsTooLarge = 92,
  IdlEventFamilyMismatch = 100,
  EventFamilyUnknown = 101,
  ProductLacksEventCallback = 102,
  EventReworded = 103,
  EventRetargeted = 104,
  EventUnmapped = 105,
  ProfileEventNotInXml = 106,
}
